































































import { IPaymentRequisition, PaymentRequisitionApprovalState } from '@/models';
import Vue, { PropType } from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'PaymentRequisitionApproverListMenu',

  props: {
    paymentRequisition: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    }
  },

  methods: {
    moment,

    getApproverStatusColor(status: PaymentRequisitionApprovalState) {
      switch (status) {
        case PaymentRequisitionApprovalState.TENTATIVE:
          return 'warning';
        case PaymentRequisitionApprovalState.APPROVED:
          return 'success darken-1';
        case PaymentRequisitionApprovalState.REJECTED:
          return 'error';
      }
    },

    getApproverStatusIcon(status: PaymentRequisitionApprovalState) {
      switch (status) {
        case PaymentRequisitionApprovalState.TENTATIVE:
          return 'mdi-account-alert-outline';
        case PaymentRequisitionApprovalState.APPROVED:
          return 'mdi-account-check-outline';
        case PaymentRequisitionApprovalState.REJECTED:
          return 'mdi-account-cancel-outline';
      }
    },

    getApproverStatusText(status: PaymentRequisitionApprovalState) {
      switch (status) {
        case PaymentRequisitionApprovalState.TENTATIVE:
          return 'Approval Pending';
        case PaymentRequisitionApprovalState.APPROVED:
          return 'Approved';
        case PaymentRequisitionApprovalState.REJECTED:
          return 'Rejected';
      }
    }
  }
});
